export default __webpack_public_path__ + "2fbff4cdacf6ac29e5bd06a89def59a7.mp3";